export default {
	"pro2": {
		"name": "pro2",
		"basic": {
			"default": "#1D1D18",
			"font": "#fff",
			"darkMode": "#1D1D18",
			"fontAlternative": "#000000",
			"alternative": "#000000",
		},
		"button": {
			"default": "#376bae",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#9bb5d6",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/pro2/logo-login.svg",
		"logocolor": "/static/img/brands/pro2/logo-login.svg",
		"logoLogin": "/static/img/brands/pro2/logo-login.svg",
		"logoencabezado": "/static/img/brands/pro2/logo-login.svg",
		"logodarkmode": "/static/img/brands/pro2/logo-login.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/pro2/background.jpg",
		"emailContacto": "desarrolloprofesional@pro2fp.es",
		"emailProblemas": "",
		"emailInscripcion": "",
		"analitycs": "",
		"footer": {
			"es": {
				"textos": [
					"Todos los derechos reservados · <a href='https://www.fpclaudiopro2.es/' target='_blank'>FP Claudio pro2</a> · Instituto Superior de Formación Profesional Sanitaria © 2023"
				],
				"links": {
					"Aviso Legal": "https://www.fpclaudiopro2.es/aviso-legal/",
					"Política de Privacidad": "https://www.fpclaudiopro2.es/politica-privacidad/",
					"Política de Cookies": "https://www.fpclaudiopro2.es/politica-de-cookies/"
				}
			}
		},
		"fonts": {
			"link": "family=Lato:400,500,700",
			"principal": "'Lato', sans-serif",
			"secundaria": "'Lato', sans-serif"
		},

		"logintexts": {
			"es": {
				"estudiantes": "Estudiantes",
				"empresas": "Empresas"
			}
		},
		//LOGIN
		"ownlogin": {
			"hasEstudiante": true,
			"hasEgresado": true,
			"textoEstudiantes": {
				"es": "Los estudiantes de pro2 disponen de usuario y contraseña propios para acceso a los servicios y sistemas del centro.<br><strong>Accede a continuación para identificarte.</strong>"
			},
			"textoEgresados": {
				"es": "Los estudiantes de pro2 disponen de usuario y contraseña propios para acceso a los servicios y sistemas del centro.<br><strong>Accede a continuación para identificarte.</strong>"
			}
		},
		"hideSAML": true,
		"ownFormLogin": ['alumnos'],
		"OneLoginForCandidatos": true,
		//CV DEL USUARIO
		"quitarCampoDiscapacidad": true,
		"otrosIntereses": false,
		//PROPUESTA DE PRACTICAS
		//"instruccionesPropuestaPracticas": "/static/img/brands/uax/instrucciones-propuesta-de-practicas.pdf",
		"showPropuestaPracticas": true,
		// "documentosPracticas": {
		// 	"url": "https://www.miotroseguro.com/"
		// },
		//REGISTRO DE LAS EMPRESAS
		"requestTipoEmpresa": true,
		"requestDireccionFullContactoEmpresa": false,
		"requestDireccionContactoEmpresa": false,
		"hideRequestFirmanteRegistro": false,
		"canRegistroAlumno": ['antiguos'],
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": true
			},
			"dni": {
				"visible": true,
				"required": true
			},
			"logo": {
				"visible": false,
			},
			"web": {
				"visible": false,
			}
		},

		"niveles": [
			{
				id: "grado",
				active: false,
				label: {
					"es": "Grado",
					"ca": "Grau"
				}
			},
			{
				id: "postgrado",
				active: false,
				label: {
					"es": "Postgrado",
					"ca": "Postgrau"
				}
			},
			{
				id: "tituloPropio",
				active: false,
				label: {
					"es": "Título Propio",
					"ca": "Títol Propi"
				}
			}
		],

		"camposOferta": {
			"otraRemuneracion": {
				"label": {
					"es": "Otra remuneración"
				},
				"showIn": ['Empleo'],
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": false
			},
			"descripcion": {
				"label": {
					"Empleo": {
						"es": "Descripción del puesto*",
					},
					"Practicas": {
						"es": "Descripción del puesto*"
					}
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			}
		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": true
			},
			"practicaRemunerada": {
				"label": {
					"es": "Práctica remunerada"
				},
				"showIn": ['Practicas']
			},
			"tipoPracticaCurriExtracurri": true,
			"solicitudParaCentroEducativo": true,
		},
		"hasResumen": true,
		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"nivelesEstudio": {
				"editable": true
			},
			"ramaTitulacion": {
				"editable": true
			}
		},
		"personales": {
			"camposEditables": true,
			"nombre": {
				"visible": true,
				"editable": false
			},
			"apellido1": {
				"visible": true,
				"editable": false
			},
			"apellido2": {
				"visible": true,
				"editable": false
			},
			"idPaisSegundaNacionalidad": {
				"visible": true,
				"editable": false
			},
			"tipoDocumentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"documentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"imagen": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": false,
				"editable": false,
				"required": false
			},
			"telefono": {
				"visible": true,
				"editable": false
			},
			"movil": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true,
				"required": false
			},
			"genero": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": false
			},
			"aceptaNewsletter": {
				"visible": false,
				"editable": false,
				"required": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false,
				"required": false
			},
			"password": false,
			"iban": {
				"visible": false,
				"editable": false
			},
			"idPaisNacionalidad": {
				"visible": false,
				"editable": false,
				"required": true
			},
			"idPaisResidencia": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": true,
					"hide": ['tipovia', 'piso', 'numero', 'puerta'],
					"nombre": {
						"es": "Dirección actual"
					}
				},
				"2": {
					"visible": true,
					"editable": false,
					"hide": ['tipovia', 'piso', 'numero', 'puerta'],
					"nombre": {
						"es": "Dirección"
					}
				}
			},
			"direccionsimple": {
				"visible": false,
				"editable": false,
			},
			"provincia": {
				"visible": true,
				"editable": false,
			},
			"localidad": {
				"visible": true,
				"editable": false,
			},
			"cp": {
				"visible": true,
				"editable": false,
			},
			"busquedaPracticasActiva": {
				"visible": true,
				"editable": false,
			}
		},
		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,

			},
			"enlace": {
				"editable": true,

			},
			"adjunto": {
				"editable": true,
				"validate": 'required'
			},

		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"retribucion": {
				"editable": true,
				"visible": true
			},
			"permisoUE": {
				"editable": false,
				"visible": true
			}
		},

		"interes": {
			"cochePropio": true,
			"carnetConducir": true,
			"busquedaActivaEmpleo": true,
			"horarioPreferenciaPracticas": true,
			"provinciaPreferenciaPracticas": true
		},
		// EMPRESA
		"ofertasEmpleo": true,
		"miEmpresa": {
			"centroTrabajo": {
				"annadir": true,
				"editar": true
			},
			"canBorrarCuenta": true,
		},
		"camposOferta": {
			"otraRemuneracion": {
				"label": {
					"es": "Otra remuneración"
				},
				"showIn": ['Empleo'],
				"required": false
			},
			"ayudaEstudio": {
				"label": {
					"es": "Ayuda al estudio"
				},
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"descripcion": {
				"label": {
					"Empleo": {
						"es": "Descripción del puesto",
					},
					"Practicas": {
						"es": "Descripción del puesto"
					}
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			}
		},
		"siteAlumnos": {
			"showPropuestaPracticas": false,
			"showDarDeBaja": true,
			"showMisEncuestas": true,
			"showMisCandidaturas": true,
			"showBuscarOfertas": true
		},
		"siteEmpresa": {
			"showPropuestaPracticas": true,
			"showMisEncuestas": true,
			"showMisCandidaturas": true
		},
		"listadoOfertasHome": true
	}
}


// WEBPACK FOOTER //
// ./src/brands/brands.js